import { Component, OnInit } from '@angular/core';
import { Router, NavigationStart, NavigationCancel, NavigationEnd, NavigationError, RouterEvent } from '@angular/router';

import { PaymentService } from './../../rest/api/payment.service';
import { PaymentService as PaymentLocalService } from './../../services/payment/payment.service';
import { AuthService } from './../../services/auth.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent implements OnInit {
  loading: boolean;
  currentRoute: any;
  plansData: any;
  lang: any;
  constructor(
    private router: Router,
    public paymentService: PaymentService,
    public paymentLocalService: PaymentLocalService,
    public translateService: TranslateService,
    public authService: AuthService
  ) {

    // const isSubscribed = this.authService.isSubscribed();
    // if (isSubscribed) {
    //   this.router.navigate(['/member']);
    // }

    this.router.events
    .subscribe((event: RouterEvent) => {
      this.navigationInterceptor(event);
    });
  }

  ngOnInit() {
    this.lang = this.translateService.currentLang ? this.translateService.currentLang :
    (localStorage.getItem('language') ? localStorage.getItem('language') : '');
    this.getPlans();
  }

  getPlans() {
    this.paymentService.getPlans(this.lang || undefined).subscribe((response: any) => {
      if (response) {
        this.plansData = response.plan || [];
      } else {
        this.plansData = [];
      }
      this.paymentLocalService.setCardPlan(this.plansData);
    });
  }

  private navigationInterceptor(event: RouterEvent): void {
    this.loading = true;
    let timer: any = null;

    if (event instanceof NavigationStart) {
      clearTimeout( timer );
      timer = setTimeout((): void => {
          this.loading = false;
      }, 1000);
    }

    if (event instanceof NavigationEnd) {
      this.currentRoute = event.url;
      clearTimeout( timer );
      timer = setTimeout((): void => {
          this.loading = false;
      }, 1000);
    }

    if (event instanceof NavigationCancel) {
      this.loading = false;
    }

    if (event instanceof NavigationError) {
      this.loading = false;
    }

  }

}
